<template>
  <div class="preparing-cashflow">
    <cashflow-loader />
  </div>
</template>

<script>
import DDLogs from '@/DDLogs';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import CashflowLoader from '@/pages/responsive-pages/authenticated/onboard2/steps/cashflow-loader/CashflowLoader';
import Segment from '../../../../../Segment';

const ONBOARDING_STATE_REFRESH_INTERVAL = 10;
const MAX_NUMBER_OF_POLLING = 6;
export default {
  async created() {
    Segment.trackUserGot('ProgressStep3Entered');
    Segment.trackUserGotToPixel('OD');
    await this.init();
    this.setLoadingState(true);
    this.startPolling();
  },
  components: {
    CashflowLoader,
  },
  name: 'PreparingCashflow',
  data() {
    return {
      pollingInterval: null,
      pollingCounter: 0,
    };
  },
  beforeDestroy() {
    clearInterval(this.pollingInterval);
  },
  computed: {
    ...mapGetters('cashflowView', ['predictedBalanceAtEndOfMonth']),
    isPredictedCashflowPositive() {
      return this.predictedBalanceAtEndOfMonth > 0;
    },
  },
  methods: {
    ...mapActions('tour', ['init']),
    ...mapActions('onboardingState', ['fetchOnboardingStateIfFinishedLoading']),
    ...mapMutations('onboardingState', ['setLoadingState']),

    startPolling() {
      this.pollingInterval = setInterval(async () => {
        await this.fetchOnboardingStateIfFinishedLoading();
        this.pollingCounter += 1;
        if (this.pollingCounter === MAX_NUMBER_OF_POLLING) {
          DDLogs.log('Stuck in PreparingCashflow');
        }
      }, ONBOARDING_STATE_REFRESH_INTERVAL * 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
  .preparing-cashflow {
    height: 100%;
  }
</style>
